export default "__VITE_ASSET__BsIXrKFC__"